<script>
export default {
    name: "LabInvestigation",

    data() {

        return {
            results: {},
            imageResults: [],
        };
    },

    props: {

        otherprescriptions: {
            type: Array,
            required: true,
        },
    },

    

    methods: {

        fetchComponentResults(inv) {
            let url = `MedicalFile/GetPatientLabResultforInvestigation`;
                url += `?PatientLabResultID=${inv.code}`;

            return this.$http.get(url).then(response => {
                this.results = response.data;
            }).catch(() => {});
        },

        fetchImages(inv) {
            let url = `Lab/GetLabInvestigationImageList`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&PatientLabResultId=${inv.code}`;

            return this.$http.get(url).then(response => {
                this.imageResults = response.data;
            }).catch(() => {});
        },

        fetchResults(inv) {
            this.$root.loading=true;
            return Promise.allSettled([ 
                    this.fetchComponentResults(inv), this.fetchImages(inv)
                ]).then(() => {
                    inv.view=true;
                    this.$root.loading=false;
                }).catch(() => { this.$root.loading=false; });
        },

        printMedicalFile() {
            window.print();
        },

        printRequests() {
          let url = `/medical-file/lab-requests/print`;
          url += `/${this.$route.params.patientID}/${this.$route.params.visitNo}`;

          window.open(
            url,
            "_blank",
            `LabRequestPrint`,
          );
        },

        printAllRequests() {
          let url = `/medical-file/lab-pending-requests/print`;
          url += `/${this.$route.params.patientID}/${this.$route.params.visitNo}`;

          window.open(
            url,
            "_blank",
            `LabRequestsPrint`,
          );
        },
        printLabResult(inv) {

window.open(`/medical-file/other-lab-result/print/${this.$route.params.patientID}/${inv.refNo}`, '_blank', `LabResultPrint`,);
},
     
        printRequest(code) {
            let url = `/medical-file/lab-pending-request/print/${this.$route.params.patientID}/${code}`;

          window.open(url, "_blank",  `LabRequestPrint`,);
        },
         printPrescriptions() {
      const url = `${this.$route.params.patientID}/${this.$route.params.visitNo}`;

      window.open(
        `/medical-file/otherprescriptions/print/${url}`,
        "_blank",
        `PrescriptionsPrint`,
      );
    }, 
    },  
   
}
</script>
<template>
<div class="w-full flex flex-wrap mt-1">
    <div class="w-full p-1 my-1">
        <div class="p-1 w-full flex flex-wrap bg-indigo-300 rounded-t-md">
            <div class="flex-1">
                <h5 class="font-bold text-white text-sm">Visit #{{ $route.query.visitNo }}</h5>
            </div>
           
        </div>

        <div class="w-full bg-gray-100 border-r-2 border-l-2 border-b-2 border-indigo-300 rounded-b p-2">
           

            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Date</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Prescription</th>
                    <th class="p-tiny">Req By</th>
                     <th class="p-tiny">Qty</th> 
                    <th class="p-tiny">Charges</th>
                    <th class="p-tiny">Totals</th>
                    
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="(prescription,idx) in otherprescriptions" :key="idx">
                        <td class="p-tiny">{{ prescription.date | dateFormat }}</td> 
                        <td class="p-tiny">{{ prescription.service }}</td>
                        <td class="p-tiny">{{ prescription.notes }}</td>
                        <td class="p-tiny">{{ prescription.clinician }}</td>
                         <td class="p-tiny">{{ prescription.quantity }} </td>
                        <td class="p-tiny">{{ prescription.charges }} </td>
                        <td class="p-tiny">{{ prescription.totalCharges }} </td>
                         
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="w-full p-1 text-right">
        <button 
            @click.prevent="printPrescriptions"
            class="btn-sm btn-primary text-xs hide--print mr-4">
                <i class="fa fa-print"></i> Print</button>
        <!-- <button 
            @click.prevent="printAllRequests"
            class="btn-sm btn-info text-xs hide--print">
                <i class="fa fa-print"></i> Pending Requests</button> -->
    </div>
</div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
